import React from 'react';
import { GenericImage } from '../generic-image';
export var ItemImage = function (_a) {
    var item = _a.item;
    var imageUrl = item.imageUrl;
    if (!imageUrl) {
        return null;
    }
    imageUrl = cropImageToSquare(imageUrl);
    return (React.createElement(GenericImage, { src: imageUrl, href: item.ctaUrl, alt: "", showAfterLoad: true }));
};
export function cropImageToSquare(imageUrl) {
    var match = imageUrl.match(/fit\/w_(\d+),h_(\d+)/);
    // NOTE: do not crop image in any way if it is cropped already
    if (match && !imageUrl.match(/crop\//)) {
        var width = parseInt(match[1], 10);
        var height = parseInt(match[2], 10);
        var edge = Math.min(width, height);
        var x = Math.floor((width - edge) / 2);
        var y = Math.floor((height - edge) / 2);
        imageUrl = imageUrl.replace(/\/file\.([a-z]+)$/, "/crop/x_" + x + ",y_" + y + ",w_" + edge + ",h_" + edge + "/file.$1");
    }
    return imageUrl;
}
//# sourceMappingURL=item-image.js.map